module.exports = __webpack_public_path__ + "img/studio-mode-btn.7df908c7.png";